// ZKX Wallet — Home v2 design tokens (mobile-web build).
//
// The screen-agnostic visual primitives (radii, breakpoints, mode gradients,
// Grainient params, mode-accent/delta helpers, the Mode/ModeEnum type) now live
// in the SHARED kit at `@common/modules/dashboard/home-kit/tokens` so the
// extension popup/tab dashboard and the mobile-web home screen share one source.
// This module re-exports those and adds the mobile-only layout/chart constants.
import { ThemeProps } from '@common/styles/themeConfig'

// Re-export the shared generic tokens so existing `../tokens` imports keep working.
export {
  RADII,
  BREAKPOINTS,
  MODE_GRADIENT,
  MODE_TOGGLE_GRADIENT_CSS,
  GRAINIENT_BASE,
  GRAINIENT_COLORS,
  getModeAccent,
  getModeAccentSoft,
  getDeltaColor,
  ModeEnum
} from '@common/modules/dashboard/home-kit/tokens'
export type { Mode } from '@common/modules/dashboard/home-kit/tokens'

// Layout constants for the desktop/tablet/mobile shells. Mobile-web only.
export const LAYOUT = {
  sidebarWidth: 288,
  // Icon-only rail width when the sidebar is collapsed.
  sidebarCollapsedWidth: 72,
  // Two-column home grid (asset table | right column) from the design.
  gridLeftWidth: 720,
  gridRightWidth: 408,
  gridGap: 24,
  contentMaxWidth: 1176,
  bottomTabHeight: 64
} as const

// Categorical palette for the portfolio-allocation donut. The theme has no
// multi-hue chart scale, so these live here as chart-layout constants (not
// per-element hardcodes). Ordered to read well clockwise: green → teal → cyan →
// blue → periwinkle → magenta → tan. `CHART_OTHERS` colors the grouped tail.
export const CHART_PALETTE = [
  '#4FB477',
  '#2BAE9E',
  '#4FD0E0',
  '#2E8FE6',
  '#7C8CF0',
  '#C857D6',
  '#C09A6B'
] as const

export const CHART_OTHERS = '#6B7280'

// Activity row "kind" accent colors (from the design's ACTIVITY_KIND map). These
// are a categorical, brand-specific palette the semantic theme doesn't express,
// so they live here as layout constants (not per-element hardcodes).
export type ActivityKind = 'shield' | 'unshield' | 'send' | 'receive' | 'swap' | 'other'

export const ACTIVITY_KIND_COLORS: Record<ActivityKind, string> = {
  shield: '#FF9230',
  unshield: '#A28BFF',
  send: '#FF6B6B',
  receive: '#31D158',
  swap: '#0291FF',
  other: '#818997'
}

// `ThemeProps` re-exported import kept implicit for helper typings consumers.
export type { ThemeProps }
